export class FunctionPlainObject {
    public name: string;
    public paramTypes: string[] = [];
    public returnType: string;
    public className: string;
    public expression: string;
}
